(function () {
  // Kaching Bundles renders "You save X%" as a subtitle line under each tier,
  // duplicating the "SAVE X%" badge next to the tier title. Hide only the
  // "You save" subtitle (not the "Standard price" one on the first tier),
  // and leave the badge as the single, highlighted savings indicator.
  function hideRedundantSavingsText(root) {
    var subtitles = (root || document).querySelectorAll('.kaching-bundles__bar-subtitle');
    subtitles.forEach(function (el) {
      if (/you save/i.test(el.textContent)) {
        el.style.display = 'none';
      }
    });
  }

  hideRedundantSavingsText();

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) {
        hideRedundantSavingsText();
        break;
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
